export default __webpack_public_path__ + "static/078-5f02b563db85ef98e80a95041df4573b.jpg";